import React from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';

import { IRootState } from '../../../../modules/stores';

import { TableImg } from './styled';
import { IImageContent } from '../../../../types/space';
import {isImgUrl} from "../../../../helpers/isImage"

type IConnectProps = ReturnType<typeof mapState>;
interface IProps {
  fieldId: string;
  recordId?: string; // Same deal. If this is passed here, it means the table element is using.
  spaceId: string;
}
interface ISmallThumb {
  smallThumbUrl: string;
}
interface ILargeThumb {
  url: string;
}
/**
 * There are three different types of images.
 * 1. Single image. The user has selected one image to display in an image element.
 * 2. Multi image. The user has selected to display all images within an image element.
 * 3. Table images. The user has selected to display the images inside a table.
 */
const SingleRaw = ({ attachment, height }: { attachment: string; height?: number }) => {
  if (!attachment || !isImgUrl(attachment)) return null;

  return (
    <img
      alt="Single"
      src={attachment}
      className="treelab-element-wrapper--image"
      style={{ height }}
    />
  );
};
const MultiRaw: React.FC<{ attachments: Array<ILargeThumb>; height?: number }> = ({
  attachments,
  height,
}) => (
  <div className="treelab-element-wrapper--image-multiple">
    {attachments.map((attach: ILargeThumb, index: number) => (
      <img alt="Multi" key={index} src={attach.url} style={{ height }} />
    ))}
  </div>
);
const TableRaw: React.FC<{ attachments: Array<ISmallThumb>; height?: number }> = ({
  attachments,
  height,
}) => {
  return (
    <>
      {attachments.map((attach: ISmallThumb, index: number) => (
        <TableImg alt="Table Lookup" key={index} src={attach.smallThumbUrl} height={height} />
      ))}
    </>
  );
};

const SingleWithFieldId: React.FC<IProps & IConnectProps> = ({ cell }) => {
  const attachment = get(cell, '[0].url');
  return <SingleRaw attachment={attachment} />;
};
const MultiWithFieldId: React.FC<IProps & IConnectProps> = ({ cell }) => {
  const attachments = cell || [];
  return <MultiRaw attachments={attachments} />;
};
const TableWithFieldId: React.FC<IProps & IConnectProps> = ({ cell, height }) => {
  const attachments = cell || [];
  return <TableRaw attachments={attachments} height={height} />;
};

/** For static images (user just uploaded it directly) */
const StaticAttachment: React.FC<{
  imageContent: IImageContent;
}> = ({ imageContent }) => {
  if (!imageContent) return null;
  if (!imageContent.url) return null;

  return <SingleRaw attachment={imageContent.url} />;
};

const mapState = ({ core, space }: IRootState, { spaceId, fieldId, recordId }: IProps) => {
  const currentSpace = space.byId[spaceId];
  const attachmentHeight = get(currentSpace, 'config.attachmentHeight');
  const height = attachmentHeight?.[fieldId ?? ''];

  return {
    cell: core.recordById[recordId || core.currentRecordId]?.cells[fieldId],
    height,
  };
};

export default {
  SingleWithFieldId: connect(mapState)(SingleWithFieldId),
  MultiWithFieldId: connect(mapState)(MultiWithFieldId),
  TableWithFieldId: connect(mapState)(TableWithFieldId),
  SingleRaw: SingleRaw,
  MultiRaw: MultiRaw,
  TableRaw: TableRaw,
  StaticAttachment: StaticAttachment,
};
